import * as React from "react";
const SvgFileAslog24Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 19,
        height: 22,
        fill: "black",
        viewBox: "0 0 19 22"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M8.586 0H18v11h-2V2h-6v8H2v10h5v2H0V8.586l.293-.293 8-8L8.586 0ZM3.414 8H8V3.414L3.414 8Zm7.379 6.5-1.647-1.646.708-.708 2 2 .353.354-.353.354-2 2-.708-.708 1.647-1.646Zm-1.647 3.354 1.647 1.646-1.647 1.646.708.708 2-2 .353-.354-.353-.354-2-2-.708.708ZM19 20h-5.5v-1H19v1Zm-5.5-5H19v-1h-5.5v1Z",
      clipRule: "evenodd"
    })
  );
export default SvgFileAslog24Px;
